import { PortalContextResponse } from "../contracts/PortalContextResponse";
import { PortalMe } from "../models/PortalMe";

/**
 * The member row a portal deep link belongs to when it is not the signed-in member's (self or a
 * ward) but another row the same email reaches (PD-0033): the page offers the switch instead of
 * falling back to self. Null when `me` has not loaded, the link names nobody or a known member, or
 * the id is foreign to the person.
 */
export const findContextOffer = (
  me: PortalMe | null,
  requestedMemberId: string | null,
  contexts: PortalContextResponse[],
): PortalContextResponse | null => {
  if (!me || !requestedMemberId) return null;
  const known = [me.self, ...me.wards].some((member) => member.memberId === requestedMemberId);
  if (known) return null;
  return contexts.find((context) => context.memberId === requestedMemberId) ?? null;
};
